import { featureToggle } from '@tsq-web/feature';
import { CommunitiesFeatureToggle } from './models/communities-feature-toggle.model';

export function getFeatureToggle(): CommunitiesFeatureToggle {
  return featureToggle as CommunitiesFeatureToggle;
}
